module.exports = __webpack_public_path__ + "img/warehouse-cart-icon.40324799.svg";